module.exports = __webpack_public_path__ + "media/assault3.a764f7d6.webm";